import * as React from 'react';
const SvgDesigningForPatients = (props) => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#designing-for-patients_svg__a)"
      stroke="#000"
      strokeWidth={4}
      strokeLinejoin="round">
      <path
        d="M5.617 97.279v-54.25c0-6.191 5.033-11.223 11.226-11.223H31.81M114.133 97.279v-54.25c0-6.191-5.033-11.223-11.226-11.223H87.939"
        strokeLinecap="square"
      />
      <path
        d="M104.778 117.856H14.972c-7.24 0-13.097-5.855-13.097-13.094h46.774v3.741h22.452v-3.741h46.774c0 7.239-5.856 13.094-13.097 13.094ZM14.972 95.408v-14.31a18.68 18.68 0 0 1 10.739-16.93l21.048-9.914 1.871-7.483M104.778 95.408v-14.31a18.68 18.68 0 0 0-10.739-16.93l-21.048-9.914-1.89-7.483"
        strokeLinecap="round"
      />
      <path
        d="M67.06 48.567c10.14-4.34 11.244-13.507 12.348-22.523.599-4.864.786-10.102-1.572-14.573-2.151-4.078-6.099-6.921-10.402-8.38a23.624 23.624 0 0 0-7.559-1.235c-2.6 0-5.201.43-7.559 1.235-4.322 1.459-8.25 4.284-10.402 8.38-2.339 4.471-2.17 9.71-1.572 14.573 1.104 9.016 2.208 18.183 12.349 22.523M46.778 54.254c0 9.353 13.097 18.706 13.097 18.706s13.097-9.353 13.097-18.706M46.778 54.254c-11.225 5.612-9.354 18.706-9.354 18.706M72.972 54.254c9.355 1.87 9.355 18.706 9.355 18.706v7.483M31.81 95.408h-5.612v-7.483c0-8.23 5.051-14.965 11.226-14.965 6.174 0 11.225 6.735 11.225 14.966v7.482h-5.613"
        strokeLinecap="round"
      />
      <path
        d="M82.327 91.667a5.612 5.612 0 1 0 0-11.225 5.612 5.612 0 0 0 0 11.225Z"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="designing-for-patients_svg__a">
        <path fill="#fff" d="M0 0h120v120H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDesigningForPatients;
